import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { isTestHost } from "../../lib/utils/DomainNameUtils.js";

 interface IABConsentData {

    /**
     * Stringa di consenso dello IAB
     */
    consentData: string,
    /**
     * GDPR è applicabile
     */
    gdprApplies: boolean,
    /**
     * il consenso ha valore globale?
     */
    hasGlobalScope: boolean,

    /**
     * stringa di consenso addizionale
     */
    additionalConsent: string

}



enum PurposeConfig {

    NO = "NO",
    FULL_AUDIENCE = "FULL_AUDIENCE",
    NO_BACK = "NO_BACK",
    FULL = "FULL",
    PART = "PART"

}

interface GooglePSAPI {
    analyticsAnonmyze(): boolean,
    allowPersonalizedAds(): boolean,
    gptAllowed(): boolean
}
 interface FacebookPSAPI {
    allowSocialButtons(): boolean,
    allowLogin(): boolean,
    allowComments(): boolean
}

 interface AmazonPSAPI {
    allowHeaderBidding(): boolean,
    allowPersonalizedAds(): boolean
}

 interface FanpagePSAPI {
    allowTechincalCookies(): boolean
}

 interface ComscorePSAPI {
    generalEnable(): boolean
}

 interface EmbedPSAPI {
    isAllowed(identifier?: string): boolean,
    isAllowedByUrl(embedSrc: string): boolean
}
 interface TwitterPSAPI{
    
    allowSocialButtons(): boolean
    
}
export interface GDPRSdk {


    google: GooglePSAPI,
    facebook: FacebookPSAPI,
    amazon: AmazonPSAPI,
    fanpage: FanpagePSAPI,

    comscore: ComscorePSAPI,
    embed: EmbedPSAPI,
    twitter: TwitterPSAPI,
    hasIABIntegration(): boolean | number,
    getIABConsentString(): boolean,
    getIABConsentData(): IABConsentData,
    getAdditionalConsentString(): string,
    purposeConsent(purposeId: number): {
        legInt: boolean,
        cons: boolean
    },
    configure(): void,
    evaluatePurposeConfig(): PurposeConfig


}


class MockGDPR implements GDPRSdk{


    private response: boolean;
    private consentString: string;
    private additionalConsent: string;
    google: GooglePSAPI;
    facebook: FacebookPSAPI;
    amazon: AmazonPSAPI;
    fanpage: FanpagePSAPI;

    comscore: ComscorePSAPI;
    embed: EmbedPSAPI;
    twitter: TwitterPSAPI;
    constructor(private simulateConsent: PurposeConfig = PurposeConfig.FULL) {
        this.response = (simulateConsent == PurposeConfig.FULL || simulateConsent == PurposeConfig.FULL_AUDIENCE);
        console.warn("****** MOCK CMP RUNNING ********", this.simulateConsent);
        this.consentString = "";
        this.additionalConsent = "";
        const self = this;
        this.google = {
            analyticsAnonmyze(): boolean {
                return self.response
            },
            allowPersonalizedAds(): boolean {
                return self.response
            },
            gptAllowed(): boolean {
                return self.response
            }
        },
        this.facebook =  {
            allowSocialButtons(): boolean {
                return self.response
            },
            allowLogin(): boolean {
                return self.response
            },
            allowComments(): boolean {
                return self.response
            }
        }
        this.amazon = { 
            allowHeaderBidding(): boolean   {
                return self.response
            },
            allowPersonalizedAds(): boolean  {
                return self.response
            }
        }
        this.fanpage = { 
            allowTechincalCookies(): boolean  {
                return self.response
            }
        }
        this.comscore = { 
            generalEnable: () =>  {
                return self.response
            }
        }
        this.embed =  {
            isAllowed(identifier?: string): boolean {
                return self.response
            },
            isAllowedByUrl(embedSrc: string): boolean  {
                return self.response
            }
         }
        this.twitter =  { 
            allowSocialButtons(): boolean {
                return self.response
            }
        }
    }


    hasIABIntegration(): number | boolean {
        return 2;
    }
    getIABConsentString(): boolean {
        return true;
    }
    getIABConsentData(): IABConsentData {
        return {
            additionalConsent: this.additionalConsent,
            consentData: this.consentString,
            gdprApplies: false,
            hasGlobalScope: false
        }
    }
    getAdditionalConsentString(): string {
        return this.additionalConsent;
    }
    purposeConsent(purposeId: number): { legInt: boolean; cons: boolean } {
        return {
            legInt: this.response,
            cons: this.response
        }
    }
    configure(): void {
        
    }
    evaluatePurposeConfig(): PurposeConfig {
        return this.simulateConsent;
    }


}


function isGDPRSdk(x: any): x is GDPRSdk {
    return ("getIABConsentString" in x && isFunction(x.getIABConsentString)) &&
            ("evaluatePurposeConfig" in x && isFunction(x.evaluatePurposeConfig));
}


interface GDPRWaiter {



    push(list: (g: GDPRSdk) => void): void;
    promise(): Promise<GDPRSdk>;

}

interface WithGDPRQueue {

    _fpcmp: {
        push(list: (g: GDPRSdk) => void): void;
    },
    _fpGDPR: GDPRSdk
}




function getQueue(w: Window): WithGDPRQueue {

    w["_fpcmp"] = w["_fpcmp"] || [];

    return ((w as unknown) as WithGDPRQueue);
}
    
const q = getQueue(window);



const prom: Promise<GDPRSdk> = new Promise((resolve, reject) => {
    q._fpcmp.push(sdk => {
        if(isGDPRSdk(sdk))
            resolve(sdk);
        else reject("Invalid GDPR Instance")
    })
})

const GDPR: GDPRWaiter = {


    push: function (list: (g: GDPRSdk) => void): void {
        q._fpcmp.push(list);
    },
    promise: function (): Promise<GDPRSdk> {
        return prom;
    }
}





const isTest = isTestHost(window.document.location.host);
const alternativeMock = new MockGDPR(isTest?PurposeConfig.FULL:PurposeConfig.NO);

export function GDPRPromise() {
    
    return GDPR.promise().catch(err => {
        return Promise.resolve(alternativeMock);
    });
}